import React from 'react';
import QRCode from 'qrcode.react';

type DownloadQrProps = {
  ios: string;
  ios_btn: string;
  android: string;
  android_btn: string;
};

/**
 * @description App Storer로 이동하는 QR을 생성하여 보여주는 컴포넌트
 * @property {string} ios iOS App Store Url
 * @property {string} ios_btn iOS Button Icon Url
 * @property {string} android Android App Store Url
 * @property {string} android_btn Android Button Icon Url
 */
function DownloadQr({ ios, ios_btn, android, android_btn }: DownloadQrProps) {
  return (
    <div className="download-qr">
      <div className="download-android">
        <p id="title">Android App</p>
        <div id="qr">
          <QRCode value={android} size={112} />
        </div>
        <a id="link" href={android} target="_blank" rel="noopener noreferrer">
          <img src={android_btn} alt="iOS icon" />
        </a>
      </div>
      <div className="download-ios">
        <p id="title">iOS App</p>
        <div id="qr">
          <QRCode value={ios} size={112} />
        </div>
        <a id="link" href={ios} target="_blank" rel="noopener noreferrer">
          <img src={ios_btn} alt="iOS icon" />
        </a>
      </div>
    </div>
  );
}

export default DownloadQr;
